import { BaseService } from './base';
import { Segment } from '../models/segment';

export class SegmentService extends BaseService<Segment> {
  override model = Segment;
  override modelName = 'segment';
  override modelLabel = 'Segment';
}
